import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { HttpClient, HttpParams } from '@angular/common/http'
import { Environment, PaginatedList, utils } from '@fabrik/common'

import { TimelogSessionGroupUpsert, TimelogSessionGroup } from '../models/TimelogSessionGroup'



export class TimelogDataService {
    constructor(private environment: Environment, private http: HttpClient) {}

    byId(tenantId: string, id: string): Observable<TimelogSessionGroup> {
        return this.http
            .get<TimelogSessionGroup>(`${this.environment.appApiHost}/api/${tenantId}/admin/timeloggroup/${id}`)
            .pipe(map(vm => ({ ...vm, id: vm.timeLogSessionGroupId })))
    }

    create(tenantId: string, payload: TimelogSessionGroupUpsert): Observable<TimelogSessionGroup> {
        return this.http.post<TimelogSessionGroup>(
            `${this.environment.appApiHost}/api/${tenantId}/admin/timeloggroup`,
            payload
        )
    }

    update(tenantId: string, payload: TimelogSessionGroupUpsert): Observable<TimelogSessionGroup> {
        return this.http.put<TimelogSessionGroup>(
            `${this.environment.appApiHost}/api/${tenantId}/admin/timeloggroup`,
            payload
        )
    }

    list(tenantId: string, args: { page?: number; limit?: number } = {}): Observable<PaginatedList<TimelogSessionGroup>> {
        let params = new HttpParams()

        Object.keys(args).forEach(key => {
            switch (key) {
                case 'page':
                    if (utils.notNullOrUndefined(args.page)) {
                        params = params.set('page', (args.page - 1).toString())
                    }
                    break

                default:
                    if (utils.notNullOrUndefined(args[key])) {
                        params = params.set(key, args[key])
                    }
            }
        })

        return this.http.get<PaginatedList<TimelogSessionGroup>>(`${this.environment.appApiHost}/api/${tenantId}/admin/timeloggroup`, { params })
    }
}
